import StandardEvent from './StandardEvent';
export class TiktokStandardEvents {
    pageView() {
        return new StandardEvent('Browse');
    }
    viewContent() {
        return new StandardEvent('ViewContent');
    }
    addToCart() {
        return new StandardEvent('AddToCart');
    }
    checkout() {
        return new StandardEvent('Checkout');
    }
    purchase() {
        return new StandardEvent('Purchase');
    }
    registration() {
        return new StandardEvent('Registration');
    }
    startCheckout() {
        return new StandardEvent('StartCheckout');
    }
    addBilling() {
        return new StandardEvent('AddBilling');
    }
    search() {
        return new StandardEvent('Search');
    }
    viewForm() {
        return new StandardEvent('ViewForm');
    }
    clickForm() {
        return new StandardEvent('ClickForm');
    }
    submitForm() {
        return new StandardEvent('SubmitForm');
    }
    viewDownloadPage() {
        return new StandardEvent('ViewDownloadPage');
    }
    clickInDownloadPage() {
        return new StandardEvent('ClickInDownloadPage');
    }
    clickToDownload() {
        return new StandardEvent('ClickToDownload');
    }
    clickButton() {
        return new StandardEvent('ClickButton');
    }
}
//# sourceMappingURL=StandardEvents.js.map